module.exports = __webpack_public_path__ + "img/blueDelete.02cdce92.svg";